import db_task_output_0 from './output/output_0';
import db_task_output_1 from './output/output_1';


window.vue.$mainVue.component('db_task_output_0', db_task_output_0);
window.vue.$mainVue.component('db_task_output_1', db_task_output_1);
